module.exports = {
    //PandasContract : "0xBddF615C7dF82585c83adc10656404d6261C6bc6", // Main contract on Rinkeby testnet
    PandasContract: "0x56c707414bC4C9d3fd71a19d3C266295Cf7f7312", // Main contract on mainnet 
    PandasContractProxy : "0x72186BFF6997C758539F811D3310bE26fc49909C" // Proxy contract 
};
